import React from "react";
import { Link } from "react-router-dom";
import { bikeNumToEnumStatuses } from "data/bike-numeric-statuses";
import getProgressBar from "views/pages/bikes/helpers/get-progress-bar";
import getChargeIcon from "views/pages/bikes/helpers/get-charge-icon";
import getGpsIcon from "views/pages/bikes/helpers/get-gps-icon";
import getLockIcon from "views/pages/bikes/helpers/get-lock-icon";

const BikeSingleInfo = ({
                          bikeInfo,
                          handleClick = false,
                          updateBikeStatus
                        }) => (
  <div className="card mb-0">
    <table className="table table-hover table-bordered table-striped table-align-middle table-sm mb-0">
      <tbody>
      <tr>
        <td>ID</td>
        <td onClick={() => (handleClick ? handleClick() : null)}>
          <Link to={`/bikes/${bikeInfo.id}`}>{bikeInfo.id}</Link>
        </td>
      </tr>
      <tr>
        <td>QR Code</td>
        <td>{bikeInfo.qr}</td>
      </tr>
      <tr>
        <td>Tags</td>
        <td>{bikeInfo.tags
          ? bikeInfo.tags.map(item => <span className="badge badge-warning mx-1" key={item}>{item}</span>)
          : "Not Set"
        }</td>
      </tr>
      <tr>
        <td>Speed</td>
        <td>
          {`${bikeInfo.condition && bikeInfo.condition.speed ? bikeInfo.condition.speed : 0} km/h`}
        </td>
      </tr>
      <tr>
        <td>Battery</td>
        <td>{getProgressBar(bikeInfo.condition)}</td>
      </tr>
      <tr>
        <td>Last Ride By</td>
        <td onClick={() => (handleClick ? handleClick() : null)}>
          {bikeInfo.lastRideUser && bikeInfo.lastRideUser
            ? <Link to={`/users/${bikeInfo.lastRideUser}`}>{bikeInfo.lastRideUser}</Link>
            : "Not Set"}
        </td>
      </tr>
      <tr>
        <td>Last Booked By</td>
        <td onClick={() => (handleClick ? handleClick() : null)}>
          {bikeInfo.lastBookUser && bikeInfo.lastBookUser
            ? <Link to={`/users/${bikeInfo.lastBookUser}`}>{bikeInfo.lastBookUser}</Link>
            : "Not Set"}
        </td>
      </tr>
      <tr>
        <td>On Charge</td>
        <td>{getChargeIcon(bikeInfo.condition)}</td>
      </tr>
      <tr>
        <td>On GPS</td>
        <td>{getGpsIcon(bikeInfo.condition)}</td>
      </tr>
      <tr>
        <td>SIM Phone</td>
        <td>{bikeInfo.sim ? bikeInfo.sim.phone : ""}</td>
      </tr>
      <tr>
        <td>SIM Serial</td>
        <td>{bikeInfo.sim ? bikeInfo.sim.serial : ""}</td>
      </tr>
      <tr>
        <td>Locked</td>
        <td>{getLockIcon(bikeInfo.condition)}</td>
      </tr>
      <tr>
        <td>Status</td>
        <td>
          <select
            className="form-control form-control-sm"
            value={bikeNumToEnumStatuses[bikeInfo.status]}
            onChange={(ev) => updateBikeStatus(ev.target.value)}
          >
            {Object.keys(bikeNumToEnumStatuses)
              .map(status => (
                <option
                  value={bikeNumToEnumStatuses[status]}
                  key={status}
                >
                  {bikeNumToEnumStatuses[status]}
                </option>
              ))}
          </select>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
);

export default BikeSingleInfo;



// WEBPACK FOOTER //
// ./src/views/pages/bikes/bike-single-info.js